<script>
import content from '@/filters/content'
import PhotoGallery from '@/components/articles/PhotoGallery'

export default {
    name: 'AppContent',
    components: {
        PhotoGallery
    },
    props: {
        html: {
            type: String,
            default: ""
        }
    },
    created(){
        this.$options.template = `<div class="app-content">${content.replacePhotoGallery(this.html)}</div>`
    }
};
</script>